import { apiClient } from './client'
import type { ApiResponse } from './client'
import type { ReplyToAddressDto, UpdateReplyToAddressesPayload } from '@/types/replyToAddresses'

export const replyToAddressesApi = {
  // The company's reply-to address book — a bare array.
  getReplyToAddresses: (clientCompanyId: string): Promise<ApiResponse<ReplyToAddressDto[]>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/ReplyToAddresses`),

  // Replaces the WHOLE list. Empty list clears the book. Server validates each email, uniqueness
  // (case-insensitive), exactly-one default when non-empty, and a max of 25 — returning 422 on a
  // broken invariant. Returns the persisted bare array on success.
  updateReplyToAddresses: (
    clientCompanyId: string,
    payload: UpdateReplyToAddressesPayload
  ): Promise<ApiResponse<ReplyToAddressDto[]>> =>
    apiClient.put(`/api/ClientCompanies/${clientCompanyId}/ReplyToAddresses`, payload),
}
